import { GET_EXPENSE_TYPES, ADD_EXPENSE_TYPE, DELETE_EXPENSE_TYPE } from 'redux/actionTypes';

export default function expenseTypes(state = [], action) {
    switch(action.type) {
        case GET_EXPENSE_TYPES:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_EXPENSE_TYPE:
            return [
                action.payload,
                ...state
            ];
        case DELETE_EXPENSE_TYPE:
            const index = state.findIndex(type => type.name === action.payload.name);
            return [
                ...state.slice(0, index),
                ...state.slice(index + 1)
            ];
        default:
            return state;
    }
};